import React, { PureComponent } from "react";

import ClientCard from "./ClientCard";
import headerImg from "../images/client.svg";

class ClientPanel extends PureComponent {
  render() {
    return (
      <div className="four-panel">
        <div className="four-panel-main-header">
          <img alt="client" src={headerImg} />{" "}
          <span className="four-panel-main-header-name">CLIENT</span>
        </div>
        {this.props.data &&
          this.props.data.Cards.map((e, idx) => (
            <ClientCard
              key={idx}
              data={e}
              additionalData={this.props.data.AdditionalData}
            />
          ))}
      </div>
    );
  }
}

export default ClientPanel;
